import {
  actionCreator,
  privateHeaders,
  showErrorMessage,
} from "../../../actions";
import { logout } from "../../login/actions";
import {
  documentsActionTypes,
  GET_DOCUMENTS_ERROR,
  GET_DOCUMENT_ERROR,
  DOWNLOAD_DOCUMENT_ERROR,
  READ_MANY_DOCUMENTS_URL,
  READ_ONE_DOCUMENT_URL,
  DOWNLOAD_DOCUMENT_URL,
} from "../constants";

export const getDocuments = ({
  pageNumber = 1,
  pageSize = 10,
  ...rest
} = {}) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(documentsActionTypes.getDocuments.REQUEST));
    let url = new URL(READ_MANY_DOCUMENTS_URL);
    const params = url.searchParams;

    // Add pagination
    params.append("limit", pageSize);
    const skip = pageNumber > 1 ? (pageNumber - 1) * pageSize : 0;
    params.append("skip", skip);

    // Add sorting
    params.append("sortKey", "updated");
    params.append("sortValue", "-1");

    // Only populate user fields; document contains campaignName and assignment_id directly
    params.append("populate", "user_id");

    // Add any additional filters
    Object.keys(rest).forEach((key) => {
      if (rest[key] !== undefined && rest[key] !== null) {
        params.append(key, rest[key]);
      }
    });

    url = url.toString();
    fetch(url, {
      method: "GET",
      headers: privateHeaders(getState),
      credentials: "include",
    })
      .then(async(response) => {
        if (!response.ok) {
          showErrorMessage(GET_DOCUMENTS_ERROR);
          dispatch(actionCreator(documentsActionTypes.getDocuments.FAILURE));
          if (response.status === 401) dispatch(logout({ statusCode: 401 }));
          return;
        }
        const data = await response.json();
        dispatch(
          actionCreator(documentsActionTypes.getDocuments.SUCCESS, data),
        );
      })
      .catch(() => {
        dispatch(actionCreator(documentsActionTypes.getDocuments.FAILURE));
        showErrorMessage(GET_DOCUMENTS_ERROR);
      });
  };
};

export const getDocument = (document_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(documentsActionTypes.getDocument.REQUEST));
    let url = new URL(`${READ_ONE_DOCUMENT_URL}/${document_id}`);
    const params = url.searchParams;
    // Only populate user fields; document contains campaignName and assignment_id directly
    params.append("populate", "user_id");
    url = url.toString();

    fetch(url, {
      method: "GET",
      headers: privateHeaders(getState),
      credentials: "include",
    })
      .then(async(response) => {
        if (!response.ok) {
          showErrorMessage(GET_DOCUMENT_ERROR);
          dispatch(actionCreator(documentsActionTypes.getDocument.FAILURE));
          if (response.status === 401) dispatch(logout({ statusCode: 401 }));
          return;
        }
        const data = await response.json();
        dispatch(
          actionCreator(documentsActionTypes.getDocument.SUCCESS, data.result),
        );
      })
      .catch(() => {
        dispatch(actionCreator(documentsActionTypes.getDocument.FAILURE));
        showErrorMessage(GET_DOCUMENT_ERROR);
      });
  };
};

export const downloadDocument = (document_id, document_title) => {
  return async(dispatch, getState) => {
    const url = `${DOWNLOAD_DOCUMENT_URL}/${document_id}/download`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: privateHeaders(getState),
        credentials: "include",
      });
      if (!response.ok) {
        showErrorMessage(DOWNLOAD_DOCUMENT_ERROR);
        if (response.status === 401) dispatch(logout({ statusCode: 401 }));
        return;
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = document_title || `document-${document_id}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      showErrorMessage(DOWNLOAD_DOCUMENT_ERROR);
    }
  };
};

export const openDocumentInNewTab = (document_id) => {
  return async(dispatch, getState) => {
    const url = `${DOWNLOAD_DOCUMENT_URL}/${document_id}/download`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: privateHeaders(getState),
        credentials: "include",
      });
      if (!response.ok) {
        showErrorMessage(DOWNLOAD_DOCUMENT_ERROR);
        if (response.status === 401) dispatch(logout({ statusCode: 401 }));
        return;
      }
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      window.open(objectUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 10000);
    } catch (error) {
      showErrorMessage(DOWNLOAD_DOCUMENT_ERROR);
    }
  };
};
